import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

import { Tooltip } from 'ui-components/components/tooltip';

import { useTaxIdentifiers } from '../../../../hooks/use-tax-identifier';
import { CustomsContext } from '../../context/context';
import { CustomsField } from '../customs-field';
import { TaxIdentifierDropdown } from './tax-identifier-dropdown';
import commonStyle from '../common-style.module.less';
import { messages } from '../messages';

export const CustomsTaxIdentifiers = () => {
  const intl = useIntl();
  const { taxIdentifiers } = useTaxIdentifiers({ includeInactive: false });
  const { fulfillmentPlanId } = useContext(CustomsContext);

  if (!fulfillmentPlanId) {
    return null;
  }

  const tooltip = (
    <Tooltip position='top' text={intl.formatMessage(messages.taxIdentifiersTooltip)}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Tooltip>
  );

  return (
    <CustomsField label={messages.taxIdentifiers} labelClassname={commonStyle['label-with-tooltip']} tooltip={tooltip}>
      <TaxIdentifierDropdown sellerTaxIdentifiers={taxIdentifiers} />
    </CustomsField>
  );
};
